import {
  UPLOAD_IMAGE_CROP_SHAPE,
  UPLOAD_IMAGE_PREVIEW_STATE,
} from '../../UploadImage'

export const CROP_SHAPE_OPTIONS = Object.values(UPLOAD_IMAGE_CROP_SHAPE)

// `interactive` = the normal flow; the rest force that state via `previewState`.
export const PREVIEW_INTERACTIVE = 'interactive'

export const PREVIEW_STATE_OPTIONS = [
  PREVIEW_INTERACTIVE,
  ...Object.values(UPLOAD_IMAGE_PREVIEW_STATE),
]

// 1×1 transparent PNG — opens preview modes in "edit" mode without a file dialog.
export const PREVIEW_PLACEHOLDER_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=='

// `real` POSTs api/v2/document/; `success`/`error` mock a settle after a delay.
export const UPLOAD_MODE = {
  ERROR: 'error',
  REAL: 'real',
  SUCCESS: 'success',
}

export const UPLOAD_MODE_OPTIONS = Object.values(UPLOAD_MODE)

export const MOCK_DELAY = 2000
